module.exports = __webpack_public_path__ + "static/media/sg2tj0.68628902.png";